import React from "react"
import Slider from "react-slick/lib"

export default class SimpleSlider extends React.Component {

  state = {
    isDragging: false
  }

  randomAutoplaySpeed = Math.floor( Math.random() * ( 5000 - 3000 + 1 ) ) + 3000

  toggleDragging = () => this.setState( { isDragging: !this.state.isDragging } );
  onClickHandler = ( event ) => {
    if ( this.props.isDragging ) {
      event.preventDefault();
    } else {
      return true
    }
  };

  render() {

    const { slidesToShow = 4, slidesToScroll = 1, centerMode = false, centerPadding = "0px", dots = true, autoplay = true, autoplaySpeed = this.randomAutoplaySpeed } = this.props
    const settings = {
      dots,
      dotsClass: "dots",
      customPaging: () => <button/>,
      appendDots: dots => (
        <li>
          {dots.map( ( dot, i ) => {
            const isActive = dot.props.className.includes( "slick-active" )
            return React.cloneElement( dot, { key: i },
              React.cloneElement( dot.props.children, { className: isActive ? "active" : "" } )
            )
          } )}
        </li>
      ),
      infinite: true,
      speed:    500,
      arrows:   true,
      slidesToShow,
      slidesToScroll,
      centerMode,
      centerPadding,
      autoplay,
      autoplaySpeed,
    };

    const { isDragging } = this.state
    return (
      <React.Fragment>
        
        <Slider {...settings}
        >
          {this.props.children}
        </Slider>
      </React.Fragment>
    );
  }
}



// WEBPACK FOOTER //
// ./src/theme/lindtbShop/components/Slider/SimpleSlider.js